<template>
    <div>
        <veui-dialog
            ui="auto"
            :open.sync="open"
        >
            <template #title>
                <span class="dialog-header">请悉知，注销律临资质面临以下影响</span>
            </template>
            <div class="content-list">
                <div class="list-item">需重新认证：再次登录时，必须重新完成入驻与资质认证流程</div>
                <div class="list-item">数据清空：以往在律临平台律师端的数据将被全部清空</div>
                <div class="list-item">流量终止：您在百度APP、百家号、问一问等平台的所有流量曝光将终止</div>
                <div class="list-item">咨询中断：您将无法再接收任何来自律临的法律咨询</div>
            </div>
            <template #foot>
                <div class="dialog-footer">
                    <div class="cancel" @click="closeDialog">
                        <span class="text">取消注销</span>
                    </div>
                    <div class="confirm" @click="confirmCancel">
                        <span class="text">继续注销</span>
                    </div>
                </div>
                <div class="footer-tip">
                    注：本操作只注销您的律临资质，如果需注销百度账号，请前往百度APP-设置-账号管理-账号注销
                </div>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
import {Dialog} from 'veui';

export default {
    name: 'cancelAuthDialog',

    components: {
        'veui-dialog': Dialog
    },

    data() {
        return {
            open: false
        };
    },

    methods: {
        openDialog() {
            this.open = true;
        },
        closeDialog() {
            this.open = false;
        },

        // 确认注销
        confirmCancel() {
            this.$emit('confirmCloseAccountPage');
        }
    }
};
</script>

<style lang="less" scoped>
.dialog-header {
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 18px;
    line-height: 18px;
    color: #1e1f24;
}

.content-list {
    width: 372px;
    counter-reset: list-item;

    .list-item {
        counter-increment: list-item;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #1e1f24;
        margin-bottom: 18px;
    }

    .list-item::before {
        content: counter(list-item) ".";
        display: inline-block;
        text-align: left;
        width: 24px;
        height: 24px;
        color: #1e1f24;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
    }

    .list-item:last-child {
        margin-bottom: 0;
    }
}

.dialog-footer {
    display: flex;
    align-items: center;

    .cancel {
        width: 166px;
        height: 40px;
        border: 1px solid #05f;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        cursor: pointer;

        .text {
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 16px;
            line-height: 16px;
            text-align: center;
            color: #05f;
        }
    }

    .cancel:hover {
        opacity: .8;
    }

    .confirm {
        width: 184px;
        height: 40px;
        border-radius: 5px;
        background-color: #05f;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 18px;
        box-sizing: border-box;
        cursor: pointer;

        .text {
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 16px;
            line-height: 16px;
            text-align: center;
            color: #fff;
        }
    }

    .confirm:hover {
        background-color: #2739d6;
    }
}

.footer-tip {
    margin-top: 18px;
    width: 372px;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0;
    color: #848691;
}

::v-deep(.veui-dialog-content-head) {
    align-items: center;
}

::v-deep(.veui-dialog-content-body) {
    padding: 0 24px;
}

::v-deep(.veui-dialog-content-foot) {
    padding: 18px 26px 0 26px;
}
</style>